// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".new-store-card__more-text {\n  padding: 2px;\n}", "",{"version":3,"sources":["webpack://./projects/marvel-snap/src/StoreCard/components/MoreText.pcss"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd","sourcesContent":[".new-store-card__more-text {\n  padding: 2px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
